import { ButtonGroup, HFlow } from 'bold-ui'
import { green, red } from 'bold-ui/lib/styles/colors'
import { SwitchButtonField } from 'components/form/field/SwitchButtonField'
import { InfoIcon } from 'components/InfoIcon'
import theme from 'config/theme'
import { StatusAvaliadoEnum } from 'graphql/types.generated'
import { useField } from 'react-final-form'
import { isUndefinedOrNull } from 'util/checks'
import { MetaPath } from 'util/metaPath'

interface PuericulturaSwitchButtonFieldProps {
  name: MetaPath<StatusAvaliadoEnum>
  usePrimaryColors: boolean
  checkable: boolean
  disable: boolean
  infoDescription: string
}

export function PuericulturaSwitchButtonField(props: PuericulturaSwitchButtonFieldProps) {
  const { name, usePrimaryColors, checkable, disable, infoDescription } = props

  const {
    input: { value, onChange, onBlur },
  } = useField<StatusAvaliadoEnum>(name.absolutePath())

  const handleClick = (buttonValue: StatusAvaliadoEnum) => {
    onChange(
      (checkable && value === buttonValue) || isUndefinedOrNull(buttonValue)
        ? StatusAvaliadoEnum.NAO_AVALIADO
        : buttonValue
    )
    onBlur()
  }

  const tooltip = disable ? 'Avaliação anterior foi marcada como "Presente" e não pode ser alterada' : ''

  return (
    <ButtonGroup>
      <HFlow hSpacing={1} justifyContent='flex-end' alignItems='center'>
        {infoDescription && <InfoIcon icon='infoCircleFilled' text={infoDescription} />}
        <SwitchButtonField
          name={name}
          clearable={checkable}
          options={getOptions(value, usePrimaryColors, tooltip, disable)}
          onChange={handleClick}
        />
      </HFlow>
    </ButtonGroup>
  )
}

const getOptions = (statusButton: StatusAvaliadoEnum, usePrimaryColors: boolean, tooltip: string, disable: boolean) => {
  const botaoPresente = (status: StatusAvaliadoEnum) => ({
    label: 'Presente',
    value: status,
    colorScale: usePrimaryColors ? theme.pallete.primary : green,
    tooltipText: tooltip,
    disabled: disable,
  })

  return [
    {
      label: 'Ausente',
      value: StatusAvaliadoEnum.AUSENTE,
      colorScale: usePrimaryColors ? theme.pallete.primary : red,
      tooltipText: tooltip,
      disabled: disable,
    },
    statusButton === StatusAvaliadoEnum.PRESENTE_COM_ATRASO
      ? botaoPresente(StatusAvaliadoEnum.PRESENTE_COM_ATRASO)
      : botaoPresente(StatusAvaliadoEnum.PRESENTE),
  ]
}
